import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'glp-1',
	options: {
		userTags: ['glp'],
	},
	landing: {
		ids: ['glp-1-landing'],
		route: {
			path: '/glp-1',
			name: 'glp-1-funnel',
		},
	},
	funnel: {
		id: 'ob-glp-1-funnel',
		route: {
			path: '/glp-1/ob/:page(.*)?',
			name: 'glp-1',
		},
		slug: 'glp-1',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-glp-1',
	},
	upsell: { routeNames: ['upsell-static-subscription-activated', 'upsell-f'] },
	upgrade: { routeName: null },
}

export default appAreaConfig
